import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { AyaQuoteStepComponent } from './aya-quote-step.component';
import { StepResolverService } from '../../../services';

export const ayaQuoteStepRoute: Route = {
  path: RouteIds.ayaQuote,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.ayaQuote) },
  component: AyaQuoteStepComponent,
};
